import { salesApi } from '../../../../config/apiClient';
import { PlatformCategoryMapping } from '../types';

export interface SaveBatchMappingItem {
  Platform: string;
  ProductName: string;
  ProductId?: string | null;
  CategoryId: string;
  CategoryName: string;
}

export const platformCategoryMappingService = {
  async getByScreen(packageScreenId: number): Promise<PlatformCategoryMapping[]> {
    const response = await salesApi.post('/api/PlatformProductCategoryMapping/get-by-screen', {
      PackageScreenId: packageScreenId,
    });
    const mappings = response.data?.Data || [];
    return mappings.map((m: any) => ({
      id: m.Id,
      companyId: m.CompanyId,
      branchId: m.BranchId || null,
      packageScreenId: m.PackageScreenId,
      platform: m.Platform,
      productName: m.ProductName,
      productId: m.ProductId || null,
      categoryId: m.CategoryId,
      categoryName: m.CategoryName,
      createdAt: m.CreatedAt,
      updatedAt: m.UpdatedAt || null,
    }));
  },

  async saveBatch(
    packageScreenId: number,
    branchId: string | null,
    mappings: SaveBatchMappingItem[]
  ): Promise<PlatformCategoryMapping[]> {
    const response = await salesApi.post('/api/PlatformProductCategoryMapping/save-batch', {
      PackageScreenId: packageScreenId,
      BranchId: branchId,
      Mappings: mappings,
    });
    const updatedMappings = response.data?.Data || [];
    return updatedMappings.map((m: any) => ({
      id: m.Id,
      companyId: m.CompanyId,
      branchId: m.BranchId || null,
      packageScreenId: m.PackageScreenId,
      platform: m.Platform,
      productName: m.ProductName,
      productId: m.ProductId || null,
      categoryId: m.CategoryId,
      categoryName: m.CategoryName,
      createdAt: m.CreatedAt,
      updatedAt: m.UpdatedAt || null,
    }));
  },

  async deleteMapping(id: number): Promise<void> {
    await salesApi.post('/api/PlatformProductCategoryMapping/delete', { Id: id });
  },
};
